import ButtonLegacy from './ButtonLegacy';

export default ButtonLegacy;
